export const PHONE_NUMBER_REGEX = /^[+]*[(]?[0-9]{0,4}[)]?[-\s./0-9]*$/;

export const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URI || 'ws://localhost:8080/';

export const MAPBOX_ATTRIBUTION =
  '&copy; <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>';
export const MAPBOX_URL = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}`;
